import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";

/* Verndale Customization ticket: TGGOPT-1941 */
addToChainAfter(chain, PopulateApiParameter, props => {
    props.apiParameter.expand?.push("properties");
});
/* End Verndale Customization ticket: TGGOPT-1941 */
